import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NavBar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-gray-800 text-white p-4">
      <div className="flex items-center justify-between">
        <Link to="/" className="font-bold ml-5 animate-rotate-x animate-thrice">
          MB
        </Link>

        {/*Desktop Menu*/}
        <div className="hidden md:flex md:mr-5">
          <Link
            to="/"
            className={`px-2 ${
              location.pathname === "/"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
          >
            Home
          </Link>
          <Link
            to="/Skills"
            className={`px-2 ${
              location.pathname === "/Skills"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
          >
            Skills
          </Link>
          <Link
            to="/Projects"
            className={`px-2 ${
              location.pathname === "/Projects"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
          >
            Projects
          </Link>
          <Link
            to="/Contact"
            className={`px-2 ${
              location.pathname === "/Contact"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
          >
            Contact
          </Link>
        </div>

        {/*Mobile Menu*/}
        <div className="md:hidden">
          <button
            type="button"
            className={` focus:outline-none focus:text-white transition-transform duration-300 ${
              isMenuOpen ? "rotate-90" : ""
            }`}
            onClick={toggleMenu}
          >
            <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
              <path
                fillRule="evenodd"
                d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        className={`${
          isMenuOpen ? "block" : "hidden"
        } md:hidden flex flex-col items-center`}
      >
        <div className="md:flex md:mr-5 flex flex-col items-center">
          <Link
            to="/"
            className={`block mt-4 md:inline-block md:mt-0 md:px-2 ${
              location.pathname === "/"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
            onClick={toggleMenu}
          >
            Home
          </Link>
          <Link
            to="/Skills"
            className={`block mt-4 md:inline-block md:mt-0 md:px-2 ${
              location.pathname === "/Skills"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
            onClick={toggleMenu}
          >
            Skills
          </Link>
          <Link
            to="/Projects"
            className={`block mt-4 md:inline-block md:mt-0 md:px-2 ${
              location.pathname === "/Projects"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
            onClick={toggleMenu}
          >
            Projects
          </Link>
          <Link
            to="/Contact"
            className={`block mt-4 md:inline-block md:mt-0 md:px-2 ${
              location.pathname === "/Contact"
                ? "text-yellow-500"
                : "hover:text-yellow-600"
            }`}
            onClick={toggleMenu}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
